import { create } from "zustand";

import { ISoccerMatchListItem, SoccerMatchStatus } from "../../../types";

type IFixtureScore = {
  match: ISoccerMatchListItem | null;
  setMatch: (match: ISoccerMatchListItem) => void;
  matchStatus: SoccerMatchStatus | null;
  setMatchStatus: (value: SoccerMatchStatus) => void;
  isMatchKeyEventsExpanded: boolean;
  setIsMatchKeyEventsExanded: (value: boolean) => void;
};
export const useFixtureScore = create<IFixtureScore>((set) => ({
  match: null,
  setMatch: (match: ISoccerMatchListItem) => {
    set(() => ({
      match,
    }));
  },
  matchStatus: null,
  setMatchStatus: (value: SoccerMatchStatus) => {
    set(() => ({
      matchStatus: value,
    }));
  },
  isMatchKeyEventsExpanded: true,
  setIsMatchKeyEventsExanded: (value: boolean) => {
    set(() => ({
      isMatchKeyEventsExpanded: value,
    }));
  },
}));
